import { useSnackbar } from '@/common/presentation/SnackbarProvider';
import { useGetJobSiteV2DTO } from '@/jobSites/application/adapters/getJobSite';
import { useGetJobSiteFormOptions } from '@/jobSites/application/adapters/getJobSiteFormOptions';
import { useEffect } from 'react';

/**
 * Hook to get job site form data using V2 DTO types
 * Uses the proper Dtos_V2_JobSite_JobSiteDto type from GraphQL schema
 */
export function useJobSiteFormData(id?: number, skipQuery?: boolean) {
  const isNew = !id;
  const { showSnackbar } = useSnackbar();

  const {
    loading: formOptionsLoading,
    error: formOptionsError,
    availableJobSiteTypes: formOptionsJobSiteTypes,
    defaultJobSiteTypeId
  } = useGetJobSiteFormOptions(!isNew || (skipQuery ?? false));

  const {
    jobSite,
    rawJobSite,
    loading: jobSiteLoading,
    error: jobSiteError,
    availableJobSiteTypes
  } = useGetJobSiteV2DTO(Number(id), skipQuery);

  useEffect(() => {
    if (jobSiteError) {
      showSnackbar('Error', jobSiteError.message || 'Failed to fetch jobSite data', 'error');
    }
    if (formOptionsError) {
      showSnackbar('Error', formOptionsError.message || 'Failed to fetch form options', 'error');
    }
  }, [jobSiteError, formOptionsError, showSnackbar]);

  return {
    isNew,
    jobSite,
    rawJobSite,
    jobSiteLoading,
    jobSiteError,
    availableJobSiteTypes,
    formOptionsLoading,
    formOptionsError,
    formOptionsJobSiteTypes,
    defaultJobSiteTypeId
  };
}
